import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IGenericPayload } from "../../../../models/common/IGenericPayload";
import { emptyStatisticsFilter, IStatisticsFilter } from "../../../../models/statistics/IStatisticsFilters";

interface IStatiticsOrganismIncidenceFilterState {
    filter: IStatisticsFilter;
}

const initialState: IStatiticsOrganismIncidenceFilterState = {
    filter: emptyStatisticsFilter(),
};

export const statisticsOrganismIncidenceFilterSlice = createSlice({
    name: "statisticsOrganismIncidenceFilterSlice",
    initialState,
    reducers: {
        resetOrganismIncidenceFilter: () => initialState,
        updateFilterProperty: (state, action: PayloadAction<IGenericPayload>) => {
            state.filter = {
                ...state.filter,
                [action.payload.name]: action.payload.value,
            };
        },
    },
});

export const {
    resetOrganismIncidenceFilter,
    updateFilterProperty,
} = statisticsOrganismIncidenceFilterSlice.actions;

export default statisticsOrganismIncidenceFilterSlice.reducer;
